import {
  CoachingFormInputData,
  enumEmpty,
  defaultCoachingSessionValues,
  CoachingFormData,
  DeliveredStatusObject,
} from '../api/CoachingForm/schema';

export const EmptyCoachingFormInputData: CoachingFormInputData = {
  id: '',
  recipient: {
    userID: '',
    userName: '',
  },
  coach: {
    userID: '',
    userName: '',
  },
  isDelivered: DeliveredStatusObject.DRAFT,
  contactReview: [],
  coachingDetails: [],
  coachingSession: {
    managerNotes: '',
    coachingTactic: enumEmpty,
    coachingMethod: enumEmpty,
    duration: enumEmpty,
    preparationTime: enumEmpty,
    coachingSummaryNotes: '',
  },
  otherReason: '',
  reason: enumEmpty,
};

export const EmptyCoachingFormData: CoachingFormData = {
  id: '',
  coach: {
    userID: '',
    userName: '',
    firstName: '',
    fullName: '',
    isManager: false,
    employmentStartDate: '',
    lastCoachedDate: '',
  },
  recipient: {
    userID: '',
    userName: '',
    firstName: '',
    fullName: '',
    isManager: false,
    employmentStartDate: '',
    lastCoachedDate: '',
  },
  createdAt: '',
  updatedAt: '',
  deliveredAt: '',
  isDelivered: enumEmpty,
  contactReview: [],
  coachingDetails: [],
  coachingSession: defaultCoachingSessionValues,
  reason: enumEmpty,
  otherReason: '',
  coachingId: '',
};
